export class ProductOptions extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['option', 'selected-variant']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'change', this.onProductOptionChange.bind(this))

    for (const option of this.els.option.elements) {
      this.listeners.add(
        option,
        'mouseenter',
        this.onProductOptionEnter.bind(this),
      )
    }
  }

  onProductOptionChange (event) {
    const target =
      event.target.tagName === 'SELECT'
        ? event.target.selectedOptions[0]
        : event.target

    const currentVariantEl = document.querySelector(
      '[data-shipping-notice-el="currentVariant"]',
    )

    if (currentVariantEl) {
      if (target.dataset.restock != null) {
        currentVariantEl.setAttribute(
          'data-current-variant-restock',
          target.dataset.restock,
        )
      }

      if (target.dataset.available === 'true') {
        currentVariantEl.setAttribute('data-current-variant-available', 'true')
      } else if (target.dataset.available === 'false') {
        currentVariantEl.setAttribute(
          'data-current-variant-available',
          'false',
        )
      }
    }

    window.BAO.dispatchEvent(window.BAO.EVENTS.PRODUCT.OPTION_SELECTED, {
      event,
      target,
      selectedOptionValues: this.selectedOptionValues,
    })
  }

  onProductOptionEnter (event) {
    window.BAO.dispatchEvent(window.BAO.EVENTS.PRODUCT.OPTION_ENTERED, {
      event,
      selectedOptionValues: this.selectedOptionValues,
    })
  }

  get selectedOptionValues () {
    const selectedOptions = Array.from(this.querySelectorAll('select')).flatMap(
      (select) =>
        Array.from(select.selectedOptions).map(
          (option) => option.dataset.optionValueId,
        ),
    )

    const checkedInputs = Array.from(
      this.querySelectorAll('fieldset input:checked'),
    ).map((input) => input.dataset.optionValueId)

    return [...selectedOptions, ...checkedInputs].filter(Boolean)
  }

  get selectedVariant () {
    return JSON.parse(this.els['selected-variant'].element.innerHTML)
  }
}

if (!customElements.get('product-options')) {
  customElements.define('product-options', ProductOptions)
}
